import React, { useEffect } from 'react';
import PresentationProjectFeedbackIcon from '@src/assets/icons/presentation-project-feedback.png';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import ActionDialog from '@src/new-components/Dialog/ActionDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { COLOR } from '@src/styles/color';
import actions from '@src/redux/actions';
import { StyledFeedbackContent } from './index.style';

const FeedbackDialog = ({ open, onClose, disableAutoClose = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      dispatch(actions.layout.setIsPanelResizeDisabled(true));
    }
  }, [open, dispatch]);

  const handleClose = () => {
    dispatch(actions.layout.setIsPanelResizeDisabled(false));
    onClose?.();
  };

  const handleAction = () => {
    window.open('https://forms.gle/tADGV1UQpFdYWUyX6', '_blank');
  };

  const renderDialogContent = () => (
    <StyledFeedbackContent>
      <div className="description">
        <Typography variant="body-20-bold" color={COLOR.label2[100]}>
          {t('presentationFeedbackTitle')}
        </Typography>
        <Typography
          variant="body-16-regular"
          color={COLOR.label2[100]}
          sx={{ textAlign: 'center' }}
        >
          {t('presentationFeedbackDescription')}
        </Typography>
      </div>
      <div className="note">
        <div className="img-containter">
          <img
            src="https://media-frontend.vbee.vn/images/package/voucher.webp"
            alt="feedback-note-icon"
            className="img"
          />
        </div>
        <Typography variant="body-14-regular" color={COLOR.label2[100]}>
          {t('presentationFeedbackNote')}
        </Typography>
      </div>
    </StyledFeedbackContent>
  );

  const renderActionButton = () => (
    <CommonButton
      variant="contained"
      customStyle={{
        height: 40,
        padding: '8px 24px',
        borderRadius: '8px',
      }}
      onClick={handleAction}
      textProps={{
        variantText: 'body-14-semibold',
        color: COLOR.indigo.default,
      }}
    >
      {t('shareFeedback')}
    </CommonButton>
  );

  return (
    <ActionDialog
      textContent={false}
      open={open}
      onClose={handleClose}
      disableAutoClose={disableAutoClose}
      image={PresentationProjectFeedbackIcon}
      imageSize="64px"
      imageContainerSize="80px"
      contentComponent={renderDialogContent()}
      width="512px"
      actionComponent={renderActionButton()}
    />
  );
};

export default FeedbackDialog;
